import React from 'react';
import { FactTable } from './FactTable';
import { LawTable } from './LawTable';
import { DebateTable } from './DebateTable';
import LayoutContainer from './Container';
import '../styles/tenminute.css';
import { FactCarousel } from './FactCarousel';

const Evidence = () => {
  const petitionURL = "https://petition.parliament.uk/petitions/660652";

  return (
    <LayoutContainer>
      <div className="main-content">
        <div className="content-row align-items-center">
          <a href={petitionURL} target="_blank" rel="noopener noreferrer" className="qr-image-container">
            <img src="images/qr-code.jpg" alt="QR Code" className="img-fluid qr-col" />
          </a>
          <h1 className="left-title">More documentary evidence</h1>
        </div>
        <div className="tables-container">
          <FactCarousel />
        </div>
      </div>
    </LayoutContainer>
  );
}

export default Evidence;
